import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DomainAuthorizationModule } from '@galaxy/email-ui/domain-authorization';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { EmailSettingsComponent } from './email-settings.component';
import { SETUP_HELP_INFO_URL_INJECTION_TOKEN } from '@galaxy/email-ui/domain-authorization/src/domain-info-card/dependencies';

@NgModule({
  declarations: [EmailSettingsComponent],
  imports: [CommonModule, GalaxyPageModule, TranslateModule, DomainAuthorizationModule, MatButtonModule],
  exports: [EmailSettingsComponent],
  providers: [
    {
      provide: SETUP_HELP_INFO_URL_INJECTION_TOKEN,
      useValue: 'https://docs.vendasta.com/marketing/email-settings/update-email-settings',
    },
  ],
})
export class EmailSettingsModule {}
